<template>
    <switch-theme-message />
    <div>
        <LaPageHeader heading="Websites">
            <template #controls v-if="!isMultiYieldSelection">
                <LaAddWebsite />
            </template>
        </LaPageHeader>

        <LaNoData v-if="isMultiYieldSelection" header="Select a publisher" description="Choose one in the navbar." />
        <template v-else>
            <WebsitesTable data-test="websites-table" :loading="!websites_final" :data="websites_final" />
            <LaDialog name="websiteDelete">
                <LaDeleteConfirmDialog item-name="website" item-property="domain" />
            </LaDialog>
        </template>
    </div>
</template>

<script>
import LaPageHeader from "@/components/PageHeader";
import WebsitesTable from "@/components/websites/WebsitesTable";
import LaAddWebsite from "@/components/button/AddWebsite";
import LaDialog from "@/components/dialog/Dialog";
import LaDeleteConfirmDialog from "@/components/dialog/DeleteConfirmDialog";
import LaNoData from "@/components/NoData";
import store from "@/store/store";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { actionTypes as websiteActionTypes, getterTypes as websiteGetterTypes } from "@/store/Websites/types";
import SwitchThemeMessage from "@/components/SwitchThemeMessage.vue";
import { actionTypes as publisherActionTypes, getterTypes as publisherGetterTypes } from "@/store/Publisher/types";

export default {
    name: "LaWebsitesView",
    components: {
        LaAddWebsite,
        LaDeleteConfirmDialog,
        LaPageHeader,
        WebsitesTable,
        LaDialog,
        SwitchThemeMessage,
        LaNoData,
    },
    setup() {
        const route = useRoute();
        const websites = computed(() => store.getters[websiteGetterTypes.getWebsitesByPublisher]);

        // URL :publisher is the source of truth for this page — sync LTBA store state
        // and fetch websites for that publisher.
        const syncPublisherFromRoute = () => {
            const paramPublisher = route.params.publisher;
            if (!paramPublisher) return;

            const allPublishers = store.getters[publisherGetterTypes.getPublishers] || [];
            const match = allPublishers.find((p) => p?.id?.toString() === paramPublisher.toString());

            if (match && !match.is_yield) {
                const currentLtba = store.getters[publisherGetterTypes.getSelectedPublisherLtba];
                if (!currentLtba || currentLtba.id !== match.id) {
                    store.dispatch(publisherActionTypes.setSelectedPublisherLtba, match);
                }
                if (store.getters[publisherGetterTypes.getSelectedMode] !== "ltba") {
                    store.dispatch(publisherActionTypes.setSelectedMode, "ltba");
                }
            }

            store.dispatch(websiteActionTypes.getDataByPublisher, { publisherId: paramPublisher });
        };

        syncPublisherFromRoute();
        watch(() => route.params.publisher, syncPublisherFromRoute);

        const websites_final = computed(() => {
            return websites.value ? websites.value.filter((item) => item.id !== "all") : [];
        });

        // Websites are per-publisher; yield multi-select can't meaningfully scope to a
        // single list here, so prompt the user to pick one. Mirrors the FeeView pattern.
        const isMultiYieldSelection = computed(() => {
            if (store.getters[publisherGetterTypes.getSelectedMode] !== "yield") return false;
            const selected = store.getters[publisherGetterTypes.getSelectedPublishersYield] || [];
            return selected.length > 1;
        });

        return { websites_final, isMultiYieldSelection };
    },
};
</script>

<style scoped></style>
